import { render } from "./AiScore.vue?vue&type=template&id=097feefa"
import script from "./AiScore.vue?vue&type=script&lang=js"
export * from "./AiScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AiScore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "097feefa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('097feefa', __exports__)) {
    api.reload('097feefa', __exports__)
  }
  
  module.hot.accept("./AiScore.vue?vue&type=template&id=097feefa", () => {
    api.rerender('097feefa', render)
  })

}


export default __exports__